<template>
  <div class="app-sidebar sidebar-shadow">
    <div class="app-header__logo">
      <div class="logo-src"></div>
      <div class="header__pane ml-auto">
        <div>
          <button
            type="button"
            class="hamburger close-sidebar-btn hamburger--elastic"
            data-class="closed-sidebar"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button
          type="button"
          class="hamburger hamburger--elastic mobile-toggle-nav"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
    <div class="app-header__menu">
      <span>
        <button
          type="button"
          class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav"
        >
          <span class="btn-icon-wrapper">
            <i class="fa fa-ellipsis-v fa-w-6"></i>
          </span>
        </button>
      </span>
    </div>
    <Sidebar></Sidebar>
  </div>
</template>
<script>
import "bootstrap";
import "@/assets/js/demo";
import "metismenu";
import $ from "jquery";
import PerfectScrollbar from "perfect-scrollbar";
import Sidebar from "@/components/plantilla/Sidebar";
export default {
  name: "Dashboard",
  components: {
    Sidebar,
  },
  mounted() {
    console.log("mounted");
    $(".vertical-nav-menu").metisMenu();
    if ($(".scrollbar-container")[0]) {
      new PerfectScrollbar(".scrollbar-sidebar", {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20,
      });
    }
  },
  beforeUpdate() {
    console.log("update");
    //$(".vertical-nav-menu").metisMenu();
  },
  update() {
    //console.log("update2")
  },
};
</script>
